export default __webpack_public_path__ + "static/media/Headshot-8.d70bc49e.jpg";